import { render, staticRenderFns } from "./whatIsVibrix.vue?vue&type=template&id=1e965a40&scoped=true&"
import script from "./whatIsVibrix.vue?vue&type=script&lang=ts&"
export * from "./whatIsVibrix.vue?vue&type=script&lang=ts&"
import style0 from "./whatIsVibrix.vue?vue&type=style&index=0&id=1e965a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e965a40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VImg,VListItem,VListItemAvatar,VListItemContent,VRow})
